

























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Response } from '@/models/response';
import { AdhocFaxViewModel } from '@/models/telephony/message';
import { FaxLine } from '@/models/admin/store';
import { ConversationTypes } from '@/enums/enums';
import { FileHelper } from '@/helper/file.helper';
import { Base } from '@/components/common/base';
import { storeService, messageService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SendFaxComponent extends Base {
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeId: number = 0;

  public form: any = {};
  public faxFields: Array<VFields<any>> = [];

  public availableFaxNumbers: FaxLine[] = [];
  public faxToSend: AdhocFaxViewModel = new AdhocFaxViewModel(
    ConversationTypes[ConversationTypes.Fax]
  );

  public requestProgress: boolean = false;

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'app.messages.fax',
        params: {
          tenantId: this.tenantId.toString(),
          enterpriseId: this.enterpriseId.toString(),
          storeId: this.storeId.toString(),
        },
      });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('faxSend.alertFormIsInvalid'));
      } else {
        this.sendFax();
      }
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(additionalButtons): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('faxSend.btnBackToListTitle') as string,
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('faxSend.btnBackToList') as string,
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.updateToolBar(null);
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.setFields();
    this.getFaxNumbers();
  }

  public setFields(): void {
    this.faxFields = [
      {
        key: 'from',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: this.$parent.$t('faxSend.from') as string,
          validations: 'required',
          required: true,
          text: 'faxNumber',
          value: 'faxNumber',
          disabled: false,
          items: this.availableFaxNumbers,
          altag: 'From',
        },
      },
      {
        key: 'to',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: this.$parent.$t('faxSend.to') as string,
          validations: 'required|min:10',
          required: true,
          disabled: false,
          mask: 'phone',
          prefix: '+1',
        },
      },
      {
        key: 'file',
        type: 'v-alynk-file-upload',
        required: false,
        templateOptions: {
          counter: 250,
          label: this.$parent.$t('faxSend.file') as string,
          validations: '',
          required: false,
          disabled: false,
          multiple: false,
          events: {
            onChange: (files, ref) => {
              if (files.length > 0) {
                this.faxToSend.file = {} as any;
                files.forEach((file) => {
                  FileHelper.getFileBytes(file.file, (base64) => {
                    this.faxToSend.file = {
                      base64,
                      extension: file.name.substring(
                        file.file.name.lastIndexOf('.')
                      ),
                      fileName: file.file.name,
                      fileSize: file.file.size,
                    };
                  });
                });
              }
            },
          },
        },
      },
    ];
  }

  public async getFaxNumbers(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.faxFields, 'from');
      const response = await storeService.getFaxLines();
      this.availableFaxNumbers = response.results;
      this.setFieldSelectItems('from', this.availableFaxNumbers);
    } finally {
      this.formlyHideSkeleton(this.faxFields, 'from');
    }
  }

  public async sendFax(): Promise<void> {
    try {
      this.requestProgress = true;
      this.$emit('update:progress', this.requestProgress);
      await await messageService.sendAdhocFax(this.faxToSend);
      this.showAlert(true, this.$t('faxSend.alertFaxSubmittedSuccessfully'));
      this.$router.push({
        name: 'app.messages.fax',
      });
    } finally {
      this.requestProgress = false;
      this.$emit('update:progress', this.requestProgress);
    }
  }

  public setFieldSelectItems(key, value): void {
    const field = this.faxFields.find((m) => {
      return m.key === key;
    });
    if (field) {
      this.$set(field.templateOptions, 'items', value);
    }
  }
}
